import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { UserImageModelInstance } from 'src/store/_models/userImage';

type WithActiveUserImageProps<P> = P & {
  activeUserImage: UserImageModelInstance;
};

type withoutActiveUserImageProps<P> = Omit<P, 'activeUserImage'>;

export function withActiveUserImage<P extends object>(Component: React.ComponentType<WithActiveUserImageProps<P>>) {
  return observer((props: withoutActiveUserImageProps<P>) => {
    const {
      project: { activeUserImageArea },
    } = useStore();
    if (activeUserImageArea?.userImage) {
      const newComponentProps = {
        ...props,
        activeUserImage: activeUserImageArea?.userImage,
      } as WithActiveUserImageProps<P>;
      return <Component {...newComponentProps} />;
    } else {
      return null;
    }
  });
}
